/*
 * @Description:
 * @Version: 1.0
 * @Author: changfeng
 * @Date: 2024-04-18 15:13:10
 * @LastEditors: changfeng
 * @LastEditTime: 2024-10-09 10:51:57
 */
export default {
	"account.title": "Ad accounts",
	"account.blank.message":
		"Rules help spend less time on ads management by automatically tracking your campaign performance and executing actions",
	"account.blank.button": "Connect Meta ad account",

	"account.profile.card1.title": "Profiles",
	"account.profile.card1.message": "connected",
	"account.profile.card1.modal.title": "Profiles",
	"account.profile.card1.modal.button": "Unlink",
	"account.profile.card2.title": "Connect profile",
	"account.profile.tips": "That’s safe. AdSurgebot doesn't collect and store your personal data.",
	"account.profile.unlink.modal.title": "Disconnect profile?",
	"account.profile.unlink.modal.text1": "Unlinking ",
	"account.profile.unlink.modal.text2":
		" profile, all accounts will be disconnected from AdSurgebot. This action affects objects associated with ad accounts:",
	"account.profile.unlink.modal.text.tip": "Automated rules will be stopped.",
	"account.profile.unlink.modal.text.button.ok": "Unlink profile",
	"account.profile.unlink.modal.text.remove.success": "Profile removed",
	"account.member.no permission.profile": `You do not have permission to connect profiles. Only members of your organization with the "Owner" role can do this.`,

	"account.table.title": "Ad accounts",
	"account.table.description": "Choose Meta Ad accounts you want AdSurgebot to work with",
	"account.table.search.name.placeholder": "Account name or ID",
	"account.table.search.profile.placeholder": "All profiles",
	"account.table.search.account.placeholder": "All ad accounts",
	"account.table.search.account.choice1": "All ad accounts",
	"account.table.search.account.choice2": "Connected",
	"account.table.search.account.choice3": "Not connected",
	"account.table.search.connectedAccount": "Connected accounts: ",
	"account.table.connectedAccount.title": "Connected accounts",
	"account.table.sync.button": "Synchronize",
	"account.table.sync.message.success": "Please wait as this may take a few minutes, you can check later.",
	"account.table.hidden.unit": "1 ad account",
	"account.table.hidden.text1": "was hidden because it cannot be connected.",
	"account.table.hidden.text2": "Show all ad accounts",
	"account.table.column.connected": "Connected",
	"account.table.column.connected.limit": "Account limit reached",
	"account.table.column.advName": "Name",
	"account.table.column.status": "Status",
	"account.table.column.status.tips": "The status of your Facebook ads accounts, from Facebook Ads Manager.",
	"account.table.column.advId": "Ad account ID",

	"account.table.column.status.enable": "Enable",
	"account.table.column.status.Restricted": "Restricted",
	"account.table.disconnect.modal.title": "Disconnect ad account?",
	"account.table.disconnect.modal.text": "This action affects objects associated with ad accounts:",
	"account.table.disconnect.modal.text.item": "· Automated rules will be stopped.",

	"account.table.operation.view binding": "Check Binding Rules"
};
